 
import { ApiError } from '@/services/ApiError';

export const handleException = (error: unknown, message: string | null = null) => {
  const prefix = message ? `${message}: ` : '';
  if (error instanceof ApiError || error instanceof Error) {
    return `${prefix}${error.message}`;
  }
  return `${prefix}${error}`;
};
